// @flow

import { css } from 'styled-components';

export default css`
  /* accessbile visual hiding: https://www.w3.org/WAI/tutorials/forms/labels/#note-on-hiding-elements */
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
`;



// WEBPACK FOOTER //
// ../react-lib/src/styles/A11yHidden.js